<!-- <app-navbar></app-navbar> -->
<!-- <div class="item item--primary"
     data-aos="fade-left"
     data-aos-anchor="#trigger-right">
  <img src="./assets/imges/Logo.gif" alt=""  class="imgsize1">
</div> -->



<div class="spinner-overlay" *ngIf="showSpinner">
  <!-- Add your spinner component or HTML/CSS here -->
  <img src="./assets/imges/spin.svg" alt="">
</div>

<app-nabar-home></app-nabar-home>

<main>
  <!-- welcome section -->
  <div class="relative pt-16 pb-32 flex content-center items-center justify-center min-h-screen-75">
    <div class="absolute top-0 w-full h-full bg-center bg-cover" style="
        background-image: url('./assets/imges/BANAN_bg.png');
      ">
      <span id="blackOverlay" class="w-full h-full absolute opacity-70 bg-color"></span>
    </div>
    <div class="container relative mx-auto">
      <div class="lg:place-items-start flex flex-wrap  ">
        <div class="w-full lg:w-6/12 text-left">
          <div class="">

            <h1 class="text-white  lg:text-5xl text-2xl text-center lg:text-start">
              Welcome to Banan
            </h1>
            <p class="mt-4 text-lg text-blueGray-200 lg:text-2xl text-center lg:text-start">

              Your digital identity at your fingerprints, and your personal details with you anywhere, anytime.
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>


  <!-- With digital identity you can section-->
  <section class="pb-16 relative pt-32">
    <div class="container mx-auto">
      <div class="flex flex-wrap  bg-white shadow-xl rounded-4xl -mt-64 py-8 px-12 relative z-10">
        <div class="container mx-auto">
          <div class="justify-center text-center flex flex-wrap mt-12">
            <div class="w-full md:w-6/12 px-12 md:px-4">
              <h2 class="font-light tracking-wide text-xl lg:text-2xl secondary-color">
                With Banan Trust Service Provider, you can</h2>
            </div>
          </div>

          <div class="justify-center flex flex-wrap mt-16">
            <div class="w-full md:w-12/12  md:px-4 px-4">
              <div class="flex flex-wrap justify-center">
                <div class="w-full md:w-6/12 lg:w-3/12  px-12 md:px-4" data-aos="fade-down-right"
                  data-aos-easing="ease-in-out-quart" data-aos-duration="2500">
                  <div class=" relative flex flex-col">
                    <img class="mx-auto" src="./assets/imges/Group 4976@2x.png" width="100" height="100" />
                    <p class="text text-center mt-5 m-auto">Access your digital identity anytime, anywhere</p>
                  </div>
                </div>

                <div class="w-full md:w-6/12 lg:w-3/12 px-12 md:px-4" data-aos="fade-down"
                  data-aos-easing="ease-in-out-quart" data-aos-duration="2500">
                  <div class="relative flex flex-col">
                    <img class="mx-auto" src="./assets/imges/Group 4977@2x.png" width="100" height="100" />
                    <p class="text text-center mt-5  m-auto">Experience faster and more efficient digital services tailored to meet your needs</p>
                  </div>
                </div>

                <div class="w-full md:w-6/12 lg:w-3/12 px-12 md:px-4" data-aos="fade-down"
                  data-aos-easing="ease-in-out-quart" data-aos-duration="2500">
                  <div class=" relative flex flex-col">
                    <img class="mx-auto" src="./assets/imges/Group 4978@2x.png" width="100" height="100" />
                    <p class="text text-center mt-5  m-auto">Enjoy robust data protection and trust interactions</p>
                  </div>
                </div>

                <div class="w-full md:w-6/12 lg:w-3/12 px-12 md:px-4">
                  <div class=" relative flex flex-col" data-aos="fade-down-left" data-aos-easing="ease-in-out-quart"
                    data-aos-duration="2500">
                    <img class="mx-auto" src="./assets/imges/Group 4979@2x.png" width="100" height="100" />
                    <p class="text text-center mt-5  m-auto">Benefit from direct access to public and private organizations
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>



  <!-- What is Banan section-->
  <section class="relative py-20">


    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">

        <h3 class="font-light tracking-wide text-3xl text-center primary-color">What is Banan?</h3>

        <p class="text-lg md:text-xl1 mt-4 info-color  leading-10 text-justify px-10 md:px-0">Banan is trust Service Provider elevates your digital experience with a secure, user-friendly platform designed for seamless interactions. Our cutting-edge encryption technology ensures your sensitive information is protected from unauthorized access, giving you complete peace of mind.
          Take control of your personal data and connect effortlessly with government and private organizations. Say goodbye to the hassle of managing multiple usernames and passwords—Banan simplifies your digital life. Your security and convenience are our priorities.
        </p>
      </div>

      <div class=" mt-24 flex justify-center ">
        <a href="" [routerLink]="['/about']"
          class="sm:ml-1 text-white  font-bold px-28 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-color-primary active:bg-blueGray-600  text-lg shadow hover:shadow-lg ease-linear transition-all">


          <span>More</span>
        </a>
      </div>

    </div>
  </section>

    <!-- Banan Services section-->
  <section class="bg-color-1 relative py-12">
    <div class="container mx-auto text-center">
      <!-- Title -->
      <div class="flex justify-center text-center mb-8">
        <div class="w-full md:w-6/12 px-4">
          <h2 class="font-light tracking-wide text-4xl info-color">Banan Services</h2>
        </div>
      </div>
  
      <!-- Services -->
      <div class="grid grid-cols-1 sm:flex sm:flex-col md:grid-cols-2 lg:flex lg:flex-row lg:justify-between gap-10 mt-12 px-10 md:px-0">
        <!-- Onboarding -->
        <div class="flex flex-col sm:flex-row items-center text-center w-full">
          <div class="w-32 h-32 mb-5 sm:mr-4 flex-shrink-0">
            <img src="./assets/imges/Group 4973.svg" alt="Onboarding" class="w-full h-full object-contain">
          </div>
          <div class="flex flex-col flex-grow">
            <h3 class="text-xl mt-3 info-color font-bold">Onboarding</h3>
            <p class="text-sm md:text-base lg:text-lg font-thin info-color text-justify mt-2">
              Effortlessly onboard customers to facilitate secure data exchange and seamless communication between registered clients and their customers.
            </p>
          </div>
        </div>
  
        <!-- Messaging -->
        <div class="flex flex-col sm:flex-row items-center text-center w-full">
          <div class="w-32 h-32 mb-5 sm:mr-4 flex-shrink-0">
            <img src="./assets/imges/Group 4968.svg" alt="Messaging" class="w-full h-full object-contain">
          </div>
          <div class="flex flex-col flex-grow">
            <h3 class="text-xl mt-3 info-color font-bold">Messaging</h3>
            <p class="text-sm md:text-base lg:text-lg font-thin info-color text-justify mt-2">
              Provide a secure channel for clients to connect with their customers, ensuring privacy, reliability, and seamless communication in every interaction.
            </p>
          </div>
        </div>
  
        <!-- Verification -->
        <div class="flex flex-col sm:flex-row items-center text-center w-full">
          <div class="w-32 h-32 mb-5 sm:mr-4 flex-shrink-0">
            <img src="./assets/imges/Group 4971.svg" alt="Verification" class="w-full h-full object-contain">
          </div>
          <div class="flex flex-col flex-grow">
            <h3 class="text-xl mt-3 info-color font-bold">Verification</h3>
            <p class="text-sm md:text-base lg:text-lg font-thin info-color text-justify mt-2">
              Empower clients to seamlessly initiate requests, ensuring customers provide explicit consent before any transaction is carried out. Simplify the approval process for secure and efficient interactions.
            </p>
          </div>
        </div>
  
        <!-- Screening -->
        <div class="flex flex-col sm:flex-row items-center text-center w-full">
          <div class="w-32 h-32 mb-5 sm:mr-4 flex-shrink-0">
            <img src="./assets/imges/screening.png" alt="Screening" class="w-full h-full object-contain">
          </div>
          <div class="flex flex-col flex-grow">
            <h3 class="text-xl mt-3 info-color font-bold">Screening</h3>
            <p class="text-sm md:text-base lg:text-lg font-thin info-color text-justify mt-2">
              Leverage advanced screening protocols to ensure authenticity, detect potential risks, and safeguard your operations. Our comprehensive approach enhances security and provides peace of mind for all stakeholders.
            </p>
          </div>
        </div>
  
        <!-- Corporate Approvals -->
        <div class="flex flex-col sm:flex-row items-center text-center w-full">
          <div class="w-32 h-32 mb-5 sm:mr-4 flex-shrink-0">
            <img src="./assets/imges/Corporate_Approvals.jpeg" alt="Corporate Approvals" class="w-full h-full object-contain">
          </div>
          <div class="flex flex-col flex-grow">
            <h3 class="text-xl mt-3 info-color font-bold">Corporate Approvals</h3>
            <p class="text-sm md:text-base lg:text-lg font-thin info-color text-justify mt-2">
              Streamline corporate workflows with an efficient, user-friendly process for obtaining official approvals. Enhance operational efficiency, ensure regulatory compliance, and simplify decision-making within organizational frameworks.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  

  <!-- Sign up with Banan section-->
  <section class="pb-20  mt-16 " id="trigger-right">
    <div class="container mx-auto px-4">
      <h3 class=" text-3xl text-center primary-color py-5">Sign up with Banan</h3>
      <div class="flex flex-wrap">
        <div class="w-full">
          <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row cursor-pointer">
            <li class="-mb-px mr-2 flex-auto text-center w-1/2 lg:w-3/12 lg:px-0 py-2 ">
              <a class="text-lg  px-5 py-3 border rounded-lg block leading-normal" (click)="toggleTabs(1)"
                [ngClass]="{'info-color bg-white': openTab !== 1, 'text-white bg-color-primary': openTab === 1}">
                Download Banan
              </a>
            </li>
            <li class="-mb-px mr-2 flex-auto text-center w-1/2 lg:w-3/12 lg:py-2 py-2 ">
              <a class="text-lg   px-5 py-3 border rounded-lg block leading-normal" (click)="toggleTabs(2)"
                [ngClass]="{'info-color bg-white': openTab !== 2, 'text-white bg-color-primary': openTab === 2}">
                Registration
              </a>
            </li>
            <li class="-mb-px mr-2  flex-auto text-center w-1/2 lg:w-3/12  lg:py-0 py-2 ">
              <a class="text-lg   px-5 py-3 border rounded-lg block leading-normal" (click)="toggleTabs(3)"
                [ngClass]="{'info-color bg-white': openTab !== 3, 'text-white bg-color-primary': openTab === 3}">
                KYC
              </a>
            </li>
          </ul>
          <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 ">
            <div class="px-4 py-5 flex-auto">
              <div class="tab-content tab-space">
                <div [ngClass]="{'hidden': openTab !== 1, 'block': openTab === 1}">
                  <div class="container mx-auto px-4">
                    <div class="items-center flex flex-wrap">
                      <div class="w-full md:w-4/12 ml-auto mr-auto mt-8" data-aos="fade-right" data-aos-duration="3000">
                        <img alt="..." class="max-w-full " src="assets/imges/exploded_mockup@2x.png" />
                        <!-- <p class="mt-4 text-lg leading-relaxed info-color">
                          For more information download our <a href="" class="primary-color underline	">User Guide </a>.
                        </p> -->
                      </div>
                      <div class="w-full md:w-5/12 ml-auto mr-auto px-4 mt-4">
                        <div class="md:pr-12">
                          <h3 class="text-2xl  primary-color
                          ">Download the Banan App Today!</h3>
                          <p class="mt-6 text-lg leading-relaxed info-color text-justify">
                            Experience convenience at your fingertips. Get the Banan app now from your favorite app store, available on (Google Play, Apple App Store,
                            Huawei App Gallery)
                          </p>
                          <div class="flex mt-6 text-justify cursor-pointer">
                            <div class="flex items-center">
                              <img src="assets/imges/app-store.png" width="90%" alt="">
                            </div>
                            <div class="flex items-center">
                              <img src="assets/imges/google-play.png" width="90%" alt="">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div [ngClass]="{'hidden': openTab !== 2, 'block': openTab === 2}">
                  <div class="container mx-auto px-4">
                    <div class="items-center flex flex-wrap">
                      <div class="w-full md:w-4/12 ml-auto mr-auto mt-8" data-aos="fade-right" data-aos-duration="3000">
                        <img alt="..." class="max-w-full " src="assets/imges/exploded_mockup1@2x.png" />

                        <!-- <p class="mt-4 text-lg leading-relaxed info-color">
                          For more information download our <a href="" class="primary-color underline	">User Guide </a>.
                        </p> -->
                      </div>
                      <div class="w-full md:w-5/12 ml-auto mr-auto px-4 mt-4">
                        <div class="md:pr-12">
                          <h3 class="text-2xl  primary-color
                          ">Register in Just 2 Simple Steps!</h3>

                          <ul class="list-none mt-6 text-justify">
                            <li class="py-2">
                              <div class="flex items-center">

                                <div>
                                  <p class="info-color text-lg">1.	Enter Your Phone Number: Type your phone number into the provided field to get started. </p>

                                </div>
                              </div>
                            </li>
                            <li class="py-2">
                              <div class="flex items-center">

                                <div>
                                  <p class="info-color text-lg"> 2.	Verify Your Number: Complete a fast and secure verification process to guarantee smooth communication and safeguard your account. </p>

                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div [ngClass]="{'hidden': openTab !== 3, 'block': openTab === 3}">
                  <div class="container mx-auto px-4">
                    <div class="items-center flex flex-wrap">
                      <div class="w-full md:w-4/12 ml-auto mr-auto  mt-8 " data-aos="fade-right"
                        data-aos-duration="3000">
                        <img alt="..." class="max-w-full " src="assets/imges/exploded_mockup2@2x.png" />
<!-- 
                        <p class="mt-4 text-lg leading-relaxed info-color ">
                          For more information download our <a href="" class="primary-color underline	">User Guide </a>.
                        </p> -->
                      </div>
                      <div class="w-full md:w-5/12 ml-auto mr-auto px-4 mt-4">
                        <div class="md:pr-12">
                          <h3 class="text-2xl  primary-color text-justify
                          ">Create your trusted Identity with Our Seamless eKYC Journey</h3>
                            <p class="mt-6 text-lg leading-relaxed info-color text-justify">
                              Say goodbye to paperwork and in-person visits! Our eKYC process allows you to:
                            </p>
                            <ul class=" list-disc pl-6 text-lg leading-relaxed info-color text-justify ">
                              <li>Upload your identification documents securely.</li>
                              <li>Verify your identity quickly and effortlessly.</li>
                              <li>Complete the entire KYC process digitally from the comfort of your home.</li>
                            </ul>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  </section>

  <!-- Our tech section-->
  <!-- <section class="pb-20  ">
    <div class="container mx-auto px-4">
      <h3 class=" text-3xl text-center primary-color py-5">Our tech</h3>
      <div class="flex flex-wrap">
        <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center" data-aos="fade-down-right"
          data-aos-easing="ease-in-out-quart" data-aos-duration="2000">
          <div class=" flex flex-col md:h-60 min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-4xl">
            <div class="px-4 py-10">



              <h6 class="text-xl  primary-color">Liveness Detection</h6>
              <p class="mt-2 mb-4 py-6 info-color">
                Liveness detection is a game-changing security technology in biometrics, able to cleverly detect if a
                fingerprint or face is real or a fake!
              </p>
            </div>
          </div>
        </div>

        <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center" data-aos="fade-down"
          data-aos-easing="ease-in-out-quart" data-aos-duration="2000">
          <div class=" flex flex-col md:h-60 min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-4xl">
            <div class=" py-10 ">

              <h6 class="text-xl  primary-color">Optical Character Recognition (OCR)</h6>
              <p class="mt-2 mb-4 px-4 py-6 info-color">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Vitae culpa, inventore alias ab atque similique quod ea reprehenderit.
              </p>
            </div>
          </div>
        </div>

        <div class="lg:pt-12 pt-6 w-full md:w-4/12 px-4 text-center" data-aos="fade-down-left"
          data-aos-easing="ease-in-out-quart" data-aos-duration="2000">
          <div class=" flex flex-col md:h-60 min-w-0 break-words bg-white w-full mb-8 shadow-lg rounded-4xl">
            <div class="px-4 py-10">

              <h6 class="text-xl  primary-color">Near-Field Communication (NFC)</h6>
              <p class="mt-2 mb-4 py-6 info-color">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Vitae culpa, inventore alias ab atque similique quod ea reprehenderit.
              </p>
            </div>
          </div>
        </div>
      </div>


    </div>
  </section> -->


  <!-- How safe is Banan section-->
  <section class="bg-color-1 overflow-hidden pb-16 relative pt-16 justify-center  ">
    <div class="container mx-auto px-4">
      <div class="flex flex-wrap justify-center">
        <div class="items-center flex flex-wrap justify-center ">

          <h3 class="font-light tracking-wide text-2xl lg:text-3xl  text-center info-color">How Safe is Banan?</h3>

          <p class="  text-lg mt-8  info-color leading-relaxed text-justify px-10 md:px-0">At Banan your identity is protected with the highest standards of security. We use advanced encryption to safeguard your data during transmission and storage, ensuring it remains inaccessible to unauthorized parties. To enhance protection, all user accounts are secured with two-factor authentication, adding an extra layer of security. Our platform undergoes regular security audits to detect and address potential vulnerabilities, giving you peace of mind that your information is always safe with us.</p>
        </div>

        <div class="w-full md:w-4/12 px-4 mr-auto ml-auto mt-32 relative md:visible ">

          <div class=" text-blueGray-700 text-55 absolute -top-100-px img_right  left-auto">
            <img src="assets/imges/bgbanan.svg" alt="" width="450px">
          </div>

        </div>
      </div>
    </div>

  </section>

  <!-- our clients section  -->
  <!-- <section class="relative py-20">
    <a
  class=" bottom-4 right-4 back-to-top delay-300"
  (click)="scrollToTop()">
<img src="../../../assets/imges/top.png" alt="" class="w-1/2 md:min-w-full">
</a>
    <div class="container mx-auto px-4 ">
      <div class="items-center flex flex-wrap justify-center ">
        <h3 class="font-semibold tracking-wide text-2xl lg:text-3xl  text-center info-color">Our Clients</h3>
      </div>
      <p class=" text-lg lg:text-2xl  mt-4 info-color text-center  ">You can safely use Banan with these approved partners</p>
      <div class=" mt-24 flex justify-center ">
        <div class="scroll-container">
          <div class="animate-scroll-mobile gap-10 md:animate-scroll-mobile  image-container ">
            <img src="./assets/imges/Scroll Group 1@2x.png" >
            <img src="./assets/imges/Scroll Group 1@2x.png" >
            <img src="./assets/imges/Scroll Group 1@2x.png"  >
            <img src="./assets/imges/Scroll Group 1@2x.png"  >
      
          </div>
        </div>
      </div>
    </div>
  </section> -->



  <!-- scroll to top -->
  <div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button (click)="scrollToTop1()">
      <img src="./assets/imges/top.png" width="50" alt="">
    </button>
  </div>

</main>







<app-footer></app-footer>